import { render, staticRenderFns } from "./Servicescope.vue?vue&type=template&id=0c801df6&scoped=true&"
import script from "./Servicescope.vue?vue&type=script&lang=js&"
export * from "./Servicescope.vue?vue&type=script&lang=js&"
import style0 from "./Servicescope.vue?vue&type=style&index=0&id=0c801df6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c801df6",
  null
  
)

export default component.exports